import { useCallback } from 'react'
import mapValues from 'lodash/mapValues'
import { message } from 'antd'
import { useNavigate, useParams } from 'react-router-dom'
import { PageHeader } from '../../Common'
import { useAsync } from '../../../hooks'
import Loading from '../../Loading'
import api from '../../../api'
import Form from './form'

export default function EditPhoneNumber() {
  const navigate = useNavigate()
  const { id } = useParams()
  const getPhoneNumber = useCallback(
    () => api.letterPhoneNumbers.getLetterPhoneNumber(id),
    [id],
  )
  const { pending, value } = useAsync(getPhoneNumber)

  const onSubmit = useCallback(
    async (data, { setErrors }) => {
      try {
        await api.letterPhoneNumbers.updateLetterPhoneNumber(id, data)

        message.success('Phone number successfully updated')
        navigate(-1)
      } catch (e) {
        if (e.response && e.response.errors) {
          setErrors(mapValues(e.response.errors, fieldErrors => fieldErrors[0]))
        } else {
          message.error('Oops, we had a problem. Please try submitting again')
        }
      }
    },
    [navigate, id],
  )

  if (pending) return <Loading large />

  return (
    <div>
      <PageHeader title="Edit Phone Number" onBack={() => navigate(-1)} />
      <Form phoneNumberData={value} onSubmit={onSubmit} />
    </div>
  )
}
